module.exports = __webpack_public_path__ + "img/pt.8399d871.svg";